const state = {
  dataAPI: {},
  dataHistory: [],
  pagination: {
    skip: 0,
    limit: 20,
  },
  jenis: "",
  outlet: "",
  lengthRiwayat: 0,
  detailSnap: {},
	detailRefund: {},
  detailEmoney: {},

  detailTopUpToModal: {},
  detailTransaksiToModal: {},
	loadingDetail: false,
};

export default state;
